<template>
  <div>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="isOpen"
        :show-close="true"
        title="Tạo nhận xét tuần/tháng"
        width="40%"
    >
      <div>
        <div>
          <div class="element_options">
            <el-row type="flex" :gutter="10">
              <el-col :span="10">
                <el-date-picker
                    class="element_input"
                    size="small"
                    v-model="dataInput.dateWeek"
                    type="week"
                    value-format="yyyy-MM-dd"
                    format="Tuần WW"
                    placeholder="Chọn tuần"
                    :clearable="true"
                ></el-date-picker>
              </el-col>
              <el-col :span="14">
                <el-button
                    size="small"
                    :loading="isLoading.week"
                    @click="createEvaluateWeekMonthRootFromDateManual('evaludateWeek')"
                    type="primary"
                >
                  Tạo NX tuần
                </el-button>
              </el-col>
            </el-row>
          </div>

          <div class="element_options">
            <el-row type="flex" :gutter="10">
              <el-col :span="10">
                <el-date-picker
                    class="element_input"
                    size="small"
                    v-model="dataInput.dateMonth"
                    type="month"
                    value-format="yyyy-MM-dd"
                    format="'Tháng 'MM-yyyy"
                    placeholder="Chọn tháng"
                    :clearable="true"
                ></el-date-picker>
              </el-col>
              <el-col :span="14">
                <el-button
                    size="small"
                    :loading="isLoading.month"
                    @click="createEvaluateWeekMonthRootFromDateManual('evaludateMonth')"
                    type="primary"
                >Tạo NX tháng
                </el-button
                >
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <div slot="footer">
        <div>
          <el-button type="danger" @click="handleClose">
            <i class="el-icon-circle-close"/>
            Đóng
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      isLoading: {
        week: false,
        month: false,
      },

      dataInput: {
        dateWeek: "",
        dateMonth: "",
      }
    }
  },
  watch: {},
  methods: {
    handleClose() {
      this.$emit("closeDialog", "comments_week_and_month");
      this.resetData();
    },

    resetData() {
      this.dataInput.dateWeek = "";
      this.dataInput.dateMonth = "";
    },

    createEvaluateWeekMonthRootFromDateManual(type) {
      let typeText = type === "evaludateWeek" ? "TUẦN" : "THÁNG";
      let dateInput = type === "evaludateWeek" ? this.dataInput.dateWeek : this.dataInput.dateMonth;

      if (dateInput === "") {
        this.$message({
          message: "Chọn " + typeText + " tạo nhận xét ",
          type: "error",
        });
        throw null;
      }
      let dataInputNew = {
        date: dateInput
      };
      this.$confirm(
          "Bạn có chắc chắn muốn tạo nhận xét " + typeText + " không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        type === "evaludateWeek" ? (this.isLoading.week = true) : (this.isLoading.month = true);
        OtherService.createEvaluateWeekMonthRootFromDateForSupperPlus(type, dataInputNew)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.isLoading.week = false;
              this.isLoading.month = false;
            });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.element_options {
  margin-bottom: 10px;
}

.element_input {
  width: 90%;
}
</style>